import { useCallback } from 'react';
import { useRBAC } from '@crehana/rbac/hooks/use-rbac';

/**
 * Hook to check user permissions and product access
 * Provides utilities for role-based access control
 *
 * @returns Object containing permission checking functions and user data
 */
export var useHasPermissions = function useHasPermissions() {
  var _useRBAC = useRBAC(),
    hasPermissions = _useRBAC.hasPermissions,
    hasProducts = _useRBAC.hasProducts,
    isUser = _useRBAC.isUser,
    isAdmin = _useRBAC.isAdmin,
    isSuperAdmin = _useRBAC.isSuperAdmin;
  var hasHana = useCallback(function () {
    return hasProducts(['HANA'], {
      operator: 'AND'
    });
  }, [hasProducts]);

  // Check specific permissions for admin view
  var hasHanaAdminPermission = hasPermissions(['HanaAdminUserView', 'HanaAdminView'], {
    operator: 'OR'
  });

  // Check specific permissions for user view
  var hasUserPermission = hasPermissions(['HanaUserView'], {
    operator: 'AND'
  });
  var hasHanaResult = hasHana();
  return {
    hasProducts: hasProducts,
    hasPermissions: hasPermissions,
    hasHana: hasHanaResult,
    isUser: isUser,
    isSuperAdmin: isSuperAdmin,
    isAdmin: isAdmin,
    hasHanaAdminPermission: hasHanaAdminPermission,
    hasUserPermission: hasUserPermission
  };
};